import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createTheme, MuiThemeProvider, responsiveFontSizes, Typography} from "@material-ui/core";

// function ptToRem(pt: number){
//     const rem = pt / 12
//     return rem + "rem"
// }

// function pxToPt(px: number){
//     // 12 / 16 = 3 / 4 = 0.75
//     return px * 0.75
// }

function pxToRem(px: number){
    const rem = px / 16;
    return rem + "rem"
}

const theme = responsiveFontSizes(createTheme({
    palette: {
        primary: {
            main: "#0063dc"
        },
        secondary: {
            main: "#c4b682"
        }
    },
    typography: {
        // fontSize: 100,
        // htmlFontSize: 20,
        // 56 - 22, 44, 32 - 18,
        // 42 - 16.5, 33, 24 - 13.5
        h1: {
            fontSize: pxToRem(48), // 64
            fontWeight: 400,
            color: "#0063dc"
        },
        h2: {
            fontSize: pxToRem(36), // 56
            fontWeight: 400,
            color: "#0063dc"
        },
        h3: {
            fontSize: pxToRem(24), // 48
            fontWeight: 400,
        },
        h4: {
            fontSize: pxToRem(18),
            fontWeight: 500,
            // color: "#0063dc"
        },
        h5: {
            fontSize: pxToRem(18),
            fontWeight: 500,
            color: "#0063dc"
        },
        h6: {
            fontSize: pxToRem(18),
        },
        subtitle1: {
            fontSize: pxToRem(18),
            color: "#606060",
            // lineHeight: "1.2"
        },
        body1: {
            fontSize: pxToRem(18),
            // lineHeight: "1.2"
        }
    }
}));

// responsiveFontSizes(

ReactDOM.render(
  <React.StrictMode>
      <MuiThemeProvider theme={theme}>
          <Typography>
              {/*<SignInScreen/>*/}
              <App/>
          </Typography>
      </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
